
import { useParams } from 'react-router-dom';
import { EmpresaFormState } from '../../../context/empresa/EmpresaFormState';
import { Form } from './form'; 

export const EmpresaFormPage = () => { 
  const { id } = useParams();
  const title = id ? "Editar Empresa" : "Crear Empresa"; 

  return (
    <EmpresaFormState>
      <br />
      <Form title={title} />
    </EmpresaFormState>
  );
};
